import parseAppKey from "../routeHelpers/parseAppKey";
import GetItem from "../dataProviders/getItem";

const checkLock = async () => {
	const appKey = parseAppKey();
	if (appKey && appKey !== "/add") {
		try {
			const data = await GetItem(`/apps/${appKey}/lock`);
			let { global, app } = data.data;
			return {
				global,
				app,
				globalIsLocked: global === "locked",
				appIsLocked: app === "locked",
			};
		} catch (error) {
			console.error(error);
			return false;
		}
	} else {
		return Promise.resolve(null);
	}
};

export default checkLock;
